<template>
  <OverviewAdmin v-if="role === 1" />
  <Overview v-else />
</template>

<script>
import OverviewAdmin from "./overview-admin";
import Overview from "./overview";
export default {
  name: "OverviewIndex",
  components: { OverviewAdmin, Overview },
  computed: {
    role() {
      return this.$store.state.role;
    },
  },
};
</script>

<style lang="scss" scoped></style>
